export enum TaskTypes {

  LOADING,
  UNLOADING,
  FUELLING,
  CUSTOMS,
  FERRY,
  FERRY_START,
  FERRY_END,
  TRAIN,
  TUNNEL,
  DOCUMENTS,
  DOCUMENT_EXCHANGE,
  MAIL,
  REST,
  REST_45H,
  PARKING,
  WASH,
  DRIVER_CHANGE,
  TRAILER_CHANGE,
  SERVICE,
  SERVICE_INNER,
  SERVICE_EXTERNAL,
  CONTAINER_CHANGE,
  CONTAINER_PICKUP,
  CONTAINER_DROPOFF,
  TRAILER_PICKUP,
  TRAILER_DROPOFF,
  PALLET_UNLOADING,
  PALLET_LOADING,
  RELOADING,
  REPACKAGING,
  CONTROL,
  EMPTY_TRIP,
  VET_INSPECTION,
  BORDER_CROSSING,
  SCALES,
  BRIDGE,
  CISTERN_WASH,
  OTHER

}

export let allSortedTaskTypes: string[] = [
  "LOADING",
  "UNLOADING",
  "FUELLING",
  "CUSTOMS",
  "FERRY",
  "FERRY_START",
  "FERRY_END",
  "TRAIN",
  "TUNNEL",
  "DOCUMENTS",
  "DOCUMENT_EXCHANGE",
  "MAIL",
  "REST",
  "REST_45H",
  "PARKING",
  "WASH",
  "DRIVER_CHANGE",
  "TRAILER_CHANGE",
  "SERVICE",
  "SERVICE_INNER",
  "SERVICE_EXTERNAL",
  "CONTAINER_CHANGE",
  "CONTAINER_PICKUP",
  "CONTAINER_DROPOFF",
  "TRAILER_PICKUP",
  "TRAILER_DROPOFF",
  "PALLET_UNLOADING",
  "PALLET_LOADING",
  "RELOADING",
  "REPACKAGING",
  "CONTROL",
  "EMPTY_TRIP",
  "VET_INSPECTION",
  "BORDER_CROSSING",
  "SCALES",
  "HAZARDOUS",
  "BRIDGE",
  "CISTERN_WASH",
  "OTHER"
];
